import { useStoreApi } from '@spazious/dollhouse-store';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogProps,
  Flex,
  Typography,
} from '@spazious/dollhouse-uikit';
import { buildId, shortSha, version } from '@spazious/vite-metadata';

import { Changelog } from '../Changelog/index.js';

export interface InfoDialogProps extends DialogProps {}

export const InfoDialog: React.FC<InfoDialogProps> = (props) => {
  const { appName } = useStoreApi();

  return (
    <Dialog {...props}>
      <DialogHeader>
        <Flex column gap="var(--spacing-gap)">
          <Typography variant="headline">
            Spazious Dollhouse {appName.charAt(0).toUpperCase() + appName.slice(1)}
          </Typography>
          <Flex column>
            <Typography size="small" variant="label">
              Version: {version}
            </Typography>
            <Typography size="small" variant="label">
              Short ID: {shortSha}
            </Typography>
            <Typography size="small" variant="label">
              Build: {buildId}
            </Typography>
          </Flex>
        </Flex>
      </DialogHeader>
      <DialogContent>
        <Changelog />
      </DialogContent>
    </Dialog>
  );
};
